import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReviewService {
  constructor() { }
  private valueSubject = new BehaviorSubject<string>('');
  currentValue$ = this.valueSubject.asObservable();
  private booleanSubject = new BehaviorSubject<boolean>(false);
  boolean$ = this.booleanSubject.asObservable();
  value: any
  updateBoolean(value: boolean) {
    this.booleanSubject.next(value);
  }
  sendValue(value: any) {
    this.value = value
    this.valueSubject.next(value);
  }
  getVariables() {
    return this.value
  }
}
